import { Receipt } from "@phosphor-icons/react"
import {
  CodenameTag,
  FormGroup,
  FormQuerySelector,
  SegmentedControl,
} from "@vesatogo/grass-core"
import { FormDateInput } from "@vesatogo/grass-dates"
import classNames from "classnames"
import dayjs from "dayjs"
import { useState } from "react"
import { CreditLimitAssessment } from "~/components/CreditManagement/Assessment/CreditLimitAssessment"
import { Invoice } from "~/components/CreditManagement/Invoice"
import { FormCard } from "~/components/FormCard"
import { PayableReceivableDate } from "~/constants/Payable"
import { useSearchBaseUsersQuery } from "~/generated/graphql"

export type BuyerCreditDetailsProps = {
  form: any
  inputProps?: any
  isDisabled?: boolean
  isSubmitted?: boolean
  defaultSegment?: "invoice" | "credit_assessment"
}

export const BuyerCreditDetails = ({
  form,
  inputProps,
  isDisabled,
  isSubmitted = false,
  defaultSegment = "invoice",
}: BuyerCreditDetailsProps) => {
  const placedBy = form?.values?.invoice?.placed_by
  type segmentType = "invoice" | "credit_assessment"
  const [segment, setSegment] = useState<segmentType>(defaultSegment)

  return (
    <FormCard
      childrenClassName={"!p-0"}
      action={
        <FormGroup
          size="sm"
          className={classNames(
            "!grid grid-cols-5 gap-1",
            segment === "invoice" ? "" : "!hidden"
          )}
        >
          <div className=""></div>
          <FormDateInput
            placeholder="From Date"
            inputGroupClassname="!font-400"
            {...inputProps("invoice.from")}
            excludeDate={date =>
              dayjs(date).isBefore(dayjs(PayableReceivableDate).startOf("d"))
            }
          />
          <FormDateInput
            placeholder="To Date"
            className={"!max-w-md"}
            inputGroupClassname="!font-400"
            {...inputProps("invoice.to")}
            excludeDate={date =>
              dayjs(date).isBefore(dayjs(PayableReceivableDate).startOf("d"))
            }
          />
          {/* <FormSelector
            size="lg"
            options={[{ id: "settled", name: "Settled" }]}
            placeholder="Status"
            inputGroupClassname="!font-400"
            {...inputProps("invoice.status")}
          /> */}
          <FormQuerySelector
            serverSideQuery
            size="sm"
            placeholder="Placed by"
            className={"!font-400 col-span-2"}
            dataHook={useSearchBaseUsersQuery}
            variables={{ groups: ["Employee", "Agent Agronomist"] }}
            getOptionLabel={option => {
              if (option === placedBy) {
                return option?.name
              }
              return (
                <>
                  <div>{option?.name}</div>
                  <CodenameTag
                    referenceId={option?.external_reference_id || "na"}
                  ></CodenameTag>
                </>
              )
            }}
            {...inputProps("invoice.placed_by")}
          />
        </FormGroup>
      }
      title={
        <SegmentedControl
          value={segment}
          onChange={(value: any) => {
            setSegment(value as segmentType)
          }}
          data={[
            {
              label: "Invoice Settlement",
              value: "invoice",
              icon: <Receipt className="mr-1" />,
            },
            {
              label: "Credit Limit Assessment",
              value: "credit_assessment",
              icon: <Receipt className="mr-1" />,
            },
          ].filter(b => b)}
        />
      }
      hideTitleIcon
    >
      {segment === "invoice" && <Invoice form={form} />}
      {segment === "credit_assessment" && (
        <CreditLimitAssessment
          form={form}
          isDisabled={isDisabled}
          isSubmitted={isSubmitted}
        />
      )}
    </FormCard>
  )
}
